module.exports = "/img/_/_/_/assets/images//app_bar.png?47e564d6a9a24f1c697b69817265f8a3";